"use client";
import { SubTypesSelect } from "@/components/Admin/CardPhoto/SubTypesSelect";
import { PhotoSubtype } from "@/interfaces/galleries/Galleries";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import React from "react";

interface SubTypeFilter {
  subtype?: string;
}
export const SubTypeFilter = ({ subtype }: SubTypeFilter) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const changeSubType = (subtype: PhotoSubtype | "all") => {
    const params = new URLSearchParams(searchParams);
    params.set("subtype", subtype);
    router.replace(`${pathname}?${params.toString()}`);
  };
  return (
    <div className="flex items-center gap-6">
      <SubTypesSelect
        selected={subtype as PhotoSubtype}
        onClick={changeSubType}
        all
      />
    </div>
  );
};
